module.exports = __webpack_public_path__ + "static/img/pure-ternera.b63d466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/pure-ternera.png
// module id = 247
// module chunks = 1